// Dashboard section: platform user counts by role shown as horizontal ranked
// bars; refetchable via its own header refresh.
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Flex, useToken } from "@chakra-ui/react";
import { MdPeople } from "react-icons/md";
import CardHeader from "../../shared/CardHeader";
import RankBars from "../../shared/RankBars";

/** Roles shown in the bars, with their stats key and Chakra color token. */
const ROLES = [
  { label: "DJ", key: "dj", token: "brand.400" },
  { label: "Auditor Pro", key: "auditorPRO", token: "blue.500" },
  { label: "Musicien", key: "musician", token: "green.500" },
  { label: "Groupes", key: "groups", token: "orange.500" },
  { label: "Entités", key: "entities", token: "red.500" }
];

const EMPTY = { dj: 0, musician: 0, auditorPRO: 0, groups: 0, entities: 0 };

/**
 * Displays user counts by role as horizontal ranked bars filling the section.
 * @returns {React.ReactElement}
 */
export default function UsersSection() {
  const [stats, setStats] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const colors = useToken("colors", ROLES.map((r) => r.token));

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get("/admin/users/stats");
      setStats({
        dj: data.dj_stat, musician: data.musician_stat, auditorPRO: data.auditor_pro_stat,
        groups: data.groups_stat, entities: data.entities_stat
      });
    } catch (error) {
      console.error("Failed to fetch user stats:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const items = ROLES.map((r, i) => ({ label: r.label, value: stats[r.key], color: colors[i] }));
  return (
    <Flex direction="column" h="100%">
      <CardHeader icon={MdPeople} title="Utilisateurs" onRefresh={load} loading={loading} />
      <RankBars items={items} />
    </Flex>
  );
}
